import { ArrowLeft } from "lucide-react";
import { cn } from "web-design-system";

export function GiftFlowHeader({
  title,
  step,
  totalSteps,
  onBack,
}: {
  title: string;
  step: number;
  totalSteps: number;
  onBack?: () => void;
}) {
  return (
    <>
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          {onBack && (
            <button type="button" onClick={onBack} aria-label="Back">
              <ArrowLeft className="h-5 w-5 text-foreground" />
            </button>
          )}
          <span className="text-lg font-semibold">{title}</span>
        </div>
        <div className="flex w-24 shrink-0 gap-1.5">
          {Array.from({ length: totalSteps }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "h-1 flex-1 rounded-full",
                i < step ? "bg-foreground" : "bg-muted-foreground/25"
              )}
            />
          ))}
        </div>
      </div>

      <div className="mt-4 border-t border-border" />
    </>
  );
}
